import { mapMutations, mapGetters, mapActions } from "vuex";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import CustomSlider from "vue-custom-range-slider";
import "vue-custom-range-slider/dist/vue-custom-range-slider.css";
import _ from "lodash";
export default {
    name: "agent-money",
    props: ["form"],
    mixin: [validationMixin],
    data() {
        return {
            value: "0",
            minValue: "0",
            maxValue: 1000,
            payload: {
                active: 0,
                city: "",
                street: "",
                house: "",
                flat: "",
                money: "",
            },
            // isEdit: true,
            // showLoader: false,
            // validationErrors: {},
        };
    },
    components: {
        // VueRangeSlider
        CustomSlider,
    },
    //   watch: {
    //     value(data) {
    //       if(data<100)
    //       {
    //         setTimeout(()=>{
    //           this.value = 100
    //         },1000)
    //       }else if (data> 1000){
    //         setTimeout(()=>{
    //           this.value = 1000
    //         },1000)
    //       }
    // return data
    //     },
    //   },
    validations() {
        return {
            payload: {
                city: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(30),
                },
                street: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(50),
                },
                house: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                flat: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                money: {},
                active: {},
            },
        };
    },
    created() {
        // this.fetchUserData();
    },
    mounted() {
        // if (this.form) {
        //   this.payload.active = this.form.active;
        //   this.payload.city = this.form.city;
        //   this.payload.street = this.form.street;
        //   this.payload.house = this.form.house;
        //   this.payload.flat = this.form.flat;
        // }
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            // addAddressLoading: 'profile/addAddressLoading',
            // removeAddressLoading: 'profile/removeAddressLoading',
            // editAddressLoading: 'profile/editAddressLoading',
        }),
        getUsersBonuses() {
            return this.user.bonuses.toFixed(2);
        },
        // cityErrors() {
        //   let error = [];
        //   if (!this.$v.payload.city.$dirty) {
        //     return error;
        //   }
        //   if (!this.$v.payload.city.minLength) {
        //     error.push(this.$t('validationMin').replace(':count', 1));
        //   }
        //   if (!this.$v.payload.city.maxLength) {
        //     error.push(this.$t('validationMax').replace(':count', 30));
        //   }
        //   if (!this.$v.payload.city.required) {
        //     error.push(this.$t('validationRequired'));
        //   }
        //   if (this.validationErrors.city) {
        //     this.validationErrors.city.forEach((row) => {
        //       error.push(row);
        //     })
        //   }
        //   return error;
        // },
        // streetErrors() {
        //   let error = [];
        //   if (!this.$v.payload.street.$dirty) {
        //     return error;
        //   }
        //   if (!this.$v.payload.street.minLength) {
        //     error.push(this.$t('validationMin').replace(':count', 1));
        //   }
        //   if (!this.$v.payload.street.maxLength) {
        //     error.push(this.$t('validationMax').replace(':count', 50));
        //   }
        //   if (!this.$v.payload.street.required) {
        //     error.push(this.$t('validationRequired'));
        //   }
        //   if (this.validationErrors.street) {
        //     this.validationErrors.street.forEach((row) => {
        //       error.push(row);
        //     })
        //   }
        //   return error;
        // },
        // houseErrors() {
        //   let error = [];
        //   if (!this.$v.payload.house.$dirty) {
        //     return error;
        //   }
        //   if (!this.$v.payload.house.minLength) {
        //     error.push(this.$t('validationMin').replace(':count', 1));
        //   }
        //   if (!this.$v.payload.house.maxLength) {
        //     error.push(this.$t('validationMax').replace(':count', 8));
        //   }
        //   if (!this.$v.payload.house.required) {
        //     error.push(this.$t('validationRequired'));
        //   }
        //   if (this.validationErrors.house) {
        //     this.validationErrors.house.forEach((row) => {
        //       error.push(row);
        //     })
        //   }
        //   return error;
        // },
        // flatErrors() {
        //   let error = [];
        //   if (!this.$v.payload.flat.$dirty) {
        //     return error;
        //   }
        //   if (!this.$v.payload.flat.minLength) {
        //     error.push(this.$t('validationMin').replace(':count', 1));
        //   }
        //   if (!this.$v.payload.flat.maxLength) {
        //     error.push(this.$t('validationMax').replace(':count', 8));
        //   }
        //   if (!this.$v.payload.flat.required) {
        //     error.push(this.$t('validationRequired'));
        //   }
        //   if (this.validationErrors.flat) {
        //     this.validationErrors.flat.forEach((row) => {
        //       error.push(row);
        //     })
        //   }
        //   return error;
        // },
        // disableButton() {
        //   if (
        //     this.payload.city === this.form.city &&
        //     this.payload.street === this.form.street &&
        //     this.payload.house === this.form.house &&
        //     this.payload.flat === this.form.flat &&
        //     this.payload.active === this.form.active
        //   ) {
        //     return true
        //   }
        //   return false
        // },
    },
    methods: {
        ...mapActions({
            // addUserAddress: `profile/ADD_USER_ADDRESS`,
            // editUserAddress: `profile/EDIT_USER_ADDRESS`,
            moneyRequest: `profile/GET_AGENT_MONEY`,
            fetchUserData: `profile/FETCH_USER_DATA`,
        }),
        ...mapMutations({}),
        changeData(data) {
            this.sendRequest(data);
        },
        sendRequest: _.debounce(function(data) {
            if (data < 1) {
                this.value = 1;
            }
            if (data > this.user.bonuses) {
                this.value = this.user.bonuses;
            }
        }, 500),
        // cancel() {
        //   this.payload.city = '';
        //   this.payload.street = '';
        //   this.payload.house = '';
        //   this.payload.flat = '';
        //   this.$nextTick(() => {
        //     this.$v.$reset()
        //   })
        // },
        // changeEdit() {
        //   this.isEdit = false;
        // },
        // editCancel() {
        //   this.isEdit = true;
        //   this.payload.active = this.form.active;
        //   this.payload.city = this.form.city;
        //   this.payload.street = this.form.street;
        //   this.payload.house = this.form.house;
        //   this.payload.flat = this.form.flat;
        //   this.$nextTick(() => {
        //     this.$v.$reset();
        //   })
        // },
        // removeAddress() {
        //   let obj = {};
        //   obj.id = this.form.id;
        //   this.showLoader = true;
        //   this.deleteUserAddress(obj)
        //     .then(() => {
        //       this.$toasted.success(this.$t('youAddressRemove'));
        //       this.fetchUserData();
        //       this.showLoader = false;
        //     }).catch(error => {
        //     if (error.response.status === 422) {
        //       this.showLoader = false;
        //     }
        //   });
        // },
        submit() {
            let obj = {};
            obj.sum = this.value;
            // if (!this.$v.$invalid) {
            this.moneyRequest(obj)
                .then(() => {
                    this.$toasted.success(this.$t("moneyRequestSend"));
                    this.fetchUserData();
                    this.value = "1";
                    // this.showLoader = false;
                    // this.isEdit = true;
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        // this.showLoader = false;
                        // this.isEdit = true;
                        console.log(error.response.status);
                    }
                });
            // }
        },
    },
};
